












import Vue from 'vue';
import {PolygonjsScene} from '@polygonjs/vue2';
import {loadSceneAndMountAsync_scene_02} from '@/polygonjs/scenes/scene_02/autogenerated/loadSceneAndMountAsync';
import { PolySceneWithNodeMap_scene_02 } from '@/polygonjs/scenes/scene_02/autogenerated/PolySceneWithNodeMap';

export default Vue.extend({
  name: 'scene-02',
  components: {
    PolygonjsScene,
  },
  data: function(){
      return {
          size: 0.2,
          scene: null
      }
  },
  computed: {
    loadFunction: ()=>loadSceneAndMountAsync_scene_02,
  },
   watch: {
      size: function(){
          this.updateSize();
      }
  },
  methods: {
      onSceneReady: function(scene: PolySceneWithNodeMap_scene_02){
          this.$data.scene = scene;
          this.updateSize();
      },
      updateSize: function(){
          const scene = this.$data.scene as PolySceneWithNodeMap_scene_02|null
          if(!scene){return}
          scene.node('/rhino/fuse1').p.dist.set(this.$data.size)
      }
  }
});
